import { render, staticRenderFns } from "./Jwm.vue?vue&type=template&id=61842501&scoped=true&"
import script from "./Jwm.vue?vue&type=script&lang=ts&"
export * from "./Jwm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61842501",
  null
  
)

export default component.exports